import { render, staticRenderFns } from "./BulkPricing.vue?vue&type=template&id=164e6267&scoped=true"
import script from "./BulkPricing.vue?vue&type=script&lang=js"
export * from "./BulkPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e6267",
  null
  
)

export default component.exports